import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/logo.svg';

const NavBar = ({ user, handleSignout }) => {
  const [isActive, setIsActive] = useState(false);
  const toggleNavbar = () => setIsActive(!isActive);


  const LoginLink = (
    <Link className='button is-primary has-text-weight-bold' to='/login'>Login</Link>
  );

  const LogoutLink = (
    <button className="button is-light" onClick={handleSignout}>Logout</button>
  );

  return (
    <nav className='navbar is-fixed-top has-border-bottom-grey' style={{zIndex: 800}} aria-label='main navigation' role='navigation'>
      <div className='container'>
        <div className='navbar-brand'>
          <Link to='/' className='navbar-item'>
            <img src={logo} alt="logo" />
          </Link>

          <div role='button' className={`navbar-burger burger ${isActive ? 'is-active' : ''}`}
            aria-expanded='false'
            data-target='navMenu'
            onClick={toggleNavbar}>
            <span aria-hidden='true'></span>
            <span aria-hidden='true'></span>
            <span aria-hidden='true'></span>
          </div>
        </div>

        <div className={`navbar-menu ${isActive ? 'is-active' : ''}`} id='navMenu'>

          <div className='navbar-end'>
          <Link className='navbar-item' to='/create/birthday'>Birthday</Link>

            <div className='navbar-item'>
              <div className='field is-grouped'>
                <p className='control'>
                  {user ? LogoutLink : LoginLink}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavBar
